import axios from 'axios';

const isDevelopment = process.env.NODE_ENV === 'development';
const localApiUrl = 'http://localhost:8000/api';
const deployedApiUrl = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: isDevelopment ? localApiUrl : (deployedApiUrl || localApiUrl),
});

// Add Token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
